import { Airplay, Home, DateRange, CalendarToday, CalendarViewWeek, CalendarViewMonth, CalendarViewDay, Reorder, Timeline, TrendingUp, TrendingDown, Settings, Policy, DataThresholdingOutlined, AssessmentOutlined, DriveFileMove } from "@mui/icons-material";

const menuConfig = [
    {
      group: "Main",
      icon: <Airplay />,
      items: [
        { to: "/", icon: <Home />, label: "Instructions" },
        { to: "/manage-data", icon: <DriveFileMove />, label: "Manage Data" },
        { to: "/metrics", icon: <DataThresholdingOutlined/>, label: "Metrics" },
      ],
    },
    {
      group: "Periodical Returns",
      icon: <DateRange />,
      items: [
        { to: "/annual", icon: <CalendarToday />, label: "Annual" },
        { to: "/monthly", icon: <CalendarViewWeek />, label: "Monthly" },
        { to: "/weekly", icon: <CalendarViewMonth />, label: "Weekly" },
        { to: "/daily", icon: <CalendarViewDay />, label: "Daily" },
        { to: "/trade-list", icon: <Reorder />, label: "TradeList" },
      ],
    },
    {
      group: "Visuals",
      icon: <Timeline />,
      items: [
        { to: "/equity-graphs", icon: <TrendingUp />, label: "Equity Graphs" },
        { to: "/drawdown-graphs", icon: <TrendingDown />, label: "Drawdown Graphs" },
        { to: "/monthly-graphs", icon: <AssessmentOutlined />, label: "Monthly Graphs" },
      ],
    },
    {
      group: "Others",
      items: [
        { to: "/settings", icon: <Settings />, label: "Settings" },
        { to: "/disclaimer", icon: <Policy />, label: "Disclaimer" },
      ],
    },
  ];

export default menuConfig;